import { Pipe, PipeTransform } from "@angular/core";
import { StatoAttoEnum } from "@app/shared/enum/stato-atto-enum";

@Pipe({
  name: "labelStatoAtti",
})
export class LabelStatoAttiPipe implements PipeTransform {
  transform(value: StatoAttoEnum, args?: any): any {
    if (value) {
      console.log("[LabelStatoAttiPipe]", value);

      switch (value) {

        /* case (StatoAttoEnum.BOZZA):

          return "BOZZA / DA REVISIONARE";

        case (StatoAttoEnum.VERIFICA):

          return "VERIFICA / DECRETO OSSERVATO / RIFIUTO CONTABILE"; */

        default:
          return value;



      }

    }
  }
}
